import React, {useState, useContext, useEffect} from 'react';
import {Link, useParams, useHistory} from 'react-router-dom';
import {Helmet} from "react-helmet";


import './najave.styles.css';

import Modal from '../../components/modal/modal';
import Button from '../../utils/buttons/Button';
import {AuthContext} from '../../utils/context/auth-context';
import LoadingSpinner from '../../utils/loader/LoadingSpinner';
import {useHttpClient} from '../../utils/input/http-hook';


const Najave = () => {

    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    const najavaId = useParams().najavaId
    
    
    const auth = useContext(AuthContext);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [loadedNajava, setLoadedNajava] = useState();

    const history = useHistory();
    
    
    useEffect(() => {
        const fetchNajavu = async () => {
          try {
            const responseData = await sendRequest(
              `${process.env.REACT_APP_BECKEND_URL}/najave/${najavaId}`
            );
            setLoadedNajava(responseData.najava);
          } catch (err) {}
        };
        fetchNajavu();
      }, [sendRequest, najavaId]);

    const showDeleteWarningHandler = () => {
        setShowConfirmModal(true);
      };
    
      const cancelDeleteHandler = () => {
        setShowConfirmModal(false);
      };

    
      const confirmDeleteHandler = async () => {
        setShowConfirmModal(false);
        try {
          await sendRequest(
            `${process.env.REACT_APP_BECKEND_URL}/najave/${najavaId}`,
            'DELETE',
            null,
            {
              Authorization: 'Bearer ' + auth.token
            }
          );
          history.push('/');         
        } catch (err) {}
      };
    
          
    
    
    
    
    return(
      <React.Fragment>  
       
      <Modal
          show={showConfirmModal}
          onCancel={cancelDeleteHandler}
          header="Are you sure?"
          footerClass="place-item__modal-actions"
          footer={
          <React.Fragment>
              <Button inverse onClick={cancelDeleteHandler}>
              CANCEL
              </Button>
              <Button danger onClick={confirmDeleteHandler}>
              DELETE
              </Button>
          </React.Fragment>
          }             
      >
          <p>
              Do you want to proceed and delete this place? Please note that it
              can't be undone thereafter.
          </p>
      </Modal>
      {isLoading && (
      <div className="center-loader">
        <LoadingSpinner />
      </div>
    )}    
    {!isLoading &&  (
      <div className="najava-page-container">   
        {loadedNajava &&              
         <div className="najave-page-detail-content content-wrapper"> 
           <Helmet>
             <title>{loadedNajava.naslov}</title>
             <meta name="description" content={loadedNajava.plan.slice(0, 100)} />
             <meta property="og:title"  content={loadedNajava.naslov}/>
             <meta property="og:image" itemprop="image"  content={loadedNajava.image}/>
             <meta property="og:description" content={loadedNajava.plan.slice(0, 100)} />
           </Helmet>            
            <div className="najave-page-gallery najave-page-detail-box">           
                <img  className="najavapage-image"src={`${process.env.REACT_APP_ASSET_URL}/${loadedNajava.image}`} alt={loadedNajava.naslov}/>
             </div>           
            <div className="najave-page-detail-info-content ">
                <h2>{loadedNajava.naslov}</h2>               
            </div>
         <div className="najave-page-section">           
            <div className="najave-page-list-date">
                <div className="najave-page-detail-title">
                    <h3>Osnovni Podaci</h3>
                </div>
              <li className="quickfact-details"><i className="najave-font icofont-ui-calendar"></i><span className="quickfact-attribute">Datum</span>  <span>{ (new Date(loadedNajava.datum)).toLocaleDateString('en-GB') }</span></li>
              <li className="quickfact-details"><i className="najave-font icofont-compass"></i><span className="quickfact-attribute">Kategorija</span>  <span>{loadedNajava.kategorija}</span></li>  
              <li className="quickfact-details"><i className="najave-font icofont-hill"></i><span className="quickfact-attribute">Najvisi Vrh</span><span>{loadedNajava.visina}</span> metara</li>
              <li className="quickfact-details"><i className="najave-font icofont-direction-sign"></i><span className="quickfact-attribute">Duzina Staze</span><span>{loadedNajava.duzina}</span> km</li>
              <li className="quickfact-details"><i className="najave-font icofont-chart-histogram"></i><span className="quickfact-attribute">Tezina Staze</span><span>{loadedNajava.tezina}</span></li>
              <li className="quickfact-details"><i className="najave-font icofont-money"></i><span className="quickfact-attribute">Troskovi </span><span>{loadedNajava.cena} din (okvirno)</span></li>
              <div className="najave-page-detail-title organizator-akcije">
                    <h3>Organizator</h3>
                </div>
                <div className="organizator-akcije-box">
                  <img className="organizator-akcije-slika"src="/img/user-12.jpg" alt=""/>                  
                  <span className="organizator-akcije-ime">{loadedNajava.organizator}</span>
                  <i className="najave-font icofont-viber"></i>
                  <span>{loadedNajava.kontakt}</span>
                 
                </div>
            </div>
            <div className="najave-page-description najave-page-detail-box">
                <div className="najave-page-detail-title">
                    <h3>Plan Akcije</h3>
                </div>
                <div className="najave-page-description-content">
                    <p className="plan-akcije">{loadedNajava.plan}</p>                 
                </div>
            </div>  
          </div>     
          {auth.isLoggedIn &&  <Link to={`/najava/${najavaId}`} className="btn-lined-tick tick-edit">Promeni</Link>}
          {auth.isLoggedIn &&  <button className="btn-lined-tick tick-delete" onClick={showDeleteWarningHandler} >Obrisi</button> } 

        </div> 

        }  

        
        
       </div>

 
          
    )}
      
      </React.Fragment>
);
}


export default Najave;